import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect } from '../../redux/connect';
import { actions as formActions } from 'react-redux-form';
import {
  changeLocationAction,
  createIssueAction,
  beginPushpinWorkflow,
  endPushpinWorkflow,
  startDropPushpinAction,
  endDropPushpinAction,
  updatePushpinAction,
  createRfiProcessStart,
  createRfiProcessEnd,
} from '../../redux/actions';
import {
  getTargetUrn,
  getOxygenMappings,
  getCurrentDocument,
  getActivePushpinAttributes,
  getAllIssues,
  getPendingIssue,
  getPendingIssueForm,
} from '../../redux/selectors';


import { Button, IconButton, SvgIcon } from '@adsk/bim360-matrix-react-components';
import { documentType, activePushpinAttributesType, pendingIssueAttributesType, pendingIssueFormAttributesType } from '../../constants/proptype-validation';
import T from 'i18n-react';
import { screenType } from '../../constants/analytics';
import IssueCreateForm from '../../components/issueCreateForm';
import targetIcon from '../../assets/images/icons/icon-target.svg';
import closeIcon from '../../assets/images/icons/icon-close.svg';
import arrowBackGray from '../../assets/images/icons/icon-arrow-back-gray.svg';

class IssueNew extends PureComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isPushPinAlertOpen: true,
      isSubmitting: false,
      error: null,
    };
    this._issueCreateFormContainer = null;
    this.handleSubmit = this._handleSubmit.bind(this);
    this.handleSaveStart = this._handleSaveStart.bind(this);
    this.handleSaveSuccess = this._handleSaveSuccess.bind(this);
    this.handleSaveError = this._handleSaveError.bind(this);
    this.handleCancelClick = this._handleCancelClick.bind(this);
  }

  componentDidMount() {
    this.props.startDropPushpinAction(this.props.pendingIssue.status);
    this.props.beginPushpinWorkflow();
    this.props.createRfiProcessStart();
  }

  componentWillUpdate(nextProps) {
    if (nextProps.pendingIssue.status !== this.props.pendingIssue.status) {
      if (nextProps.issuePushpin) {
        this.props.updatePushpinAction({
          id: nextProps.issuePushpin.id,
          label: nextProps.issuePushpin.label,
          status: nextProps.pendingIssue.status,
          position: nextProps.issuePushpin.position,
          objectId: nextProps.issuePushpin.objectId,
          viewerState: nextProps.issuePushpin.viewerState,
          externalId: nextProps.issuePushpin.externalId,
          attributesVersion: nextProps.issuePushpin.attributesVersion,
        });
      } else {
        this.props.endDropPushpinAction();
        this.props.startDropPushpinAction(nextProps.pendingIssue.status);
      }

    }
  }

  componentWillUnmount() {
    this.props.endDropPushpinAction();
    this.props.resetFormAction('pendingIssue');
    this.props.resetValidityFormAction('pendingIssue');
    this.props.endPushpinWorkflow();
    this.props.createRfiProcessEnd();
  }

  _handleSubmit() {
    this._issueCreateFormContainer && this._issueCreateFormContainer.saveIssue();
  }

  _handleSaveStart() {
    this.setState({
      isSubmitting: true,
      error: null,
    });
  }

  _handleSaveSuccess() {
    const { changeLocationAction, onCreateSuccess } = this.props;
    this.setState({ isSubmitting: false });
    onCreateSuccess && onCreateSuccess();
    changeLocationAction('/rfis');
  }

  _handleCancelClick() {
    const { changeLocationAction, onCancel } = this.props;
    onCancel && onCancel();
    changeLocationAction('/rfis');
  }

  _handleSaveError(error) {
    this.setState({
      isSubmitting: false,
      error: error || true,
    });
  }

  renderPushPinToast() {
    const { issuePushpin } = this.props;
    const left = `${window.innerWidth / 2}px`;

    if (issuePushpin || !this.state.isPushPinAlertOpen) {
      return null;
    }
    return (
      <div className="isui-form__push-pin-toast" style={{ left }} >
        <SvgIcon className="isui-form__push-pin-toast-icon" width="24px" height="24px">
          {targetIcon}
        </SvgIcon>
        {T.translate('new.pushPinAlert')}

        <IconButton className="isui-form__push-pin-toast-close" onClick={() => { this.setState({ isPushPinAlertOpen: false }); }}>
          <SvgIcon width="13px" height="13px">
            {closeIcon}
          </SvgIcon>
        </IconButton>
      </div>
    );
  }

  render() {
    const { pendingIssueForm, issuePushpin, document, targetUrn } = this.props;
    const { isSubmitting, error } = this.state;
    const disabled = !issuePushpin;
    const saveButtonClasses = cx('IssueNew__create-button', {
      ['IssueNew__create-button--saving']: isSubmitting,
    });
    const saveButtonText = isSubmitting ? T.translate('new.creating') : T.translate('new.create');
    return (
      <div className="IssueNew">
        <div className="IssueNew__header">
          <IconButton
            className="IssueNew__back-link"
            onClick={this.handleCancelClick}
            styleType={IconButton.StyleType.MINIMAL}
          >
            <SvgIcon width="11px" height="17px">
              {arrowBackGray}
            </SvgIcon>
          </IconButton>

          {T.translate('new.addHeader')}
        </div>
        {this.renderPushPinToast()}
        <IssueCreateForm
          ref={(c) => { this._issueCreateFormContainer = c; }}
          origin={screenType.PANEL}
          onSaveStart={this.handleSaveStart}
          onSaveSuccess={this.handleSaveSuccess}
          onSaveError={this.handleSaveError}
          disabled={disabled}
          isSubmitting={isSubmitting}
          error={error}
          focusForm={!disabled}
          issuePushpin={issuePushpin}
          document={document}
          targetUrn={targetUrn}
          container={this}
        />
        <div className="IssueNew__footer">
          <Button
            data-testid="IssueNew__cancelButton"
            styleType={Button.StyleType.LINK_SECONDARY}
            onClick={this.handleCancelClick}
          >
            {T.translate('navigation.cancel')}
          </Button>
          <Button
            styleType={Button.StyleType.PRIMARY}
            className={saveButtonClasses}
            data-testid="IssueNew__createButton"
            onClick={this.handleSubmit}
            disabled={disabled || pendingIssueForm.pristine || isSubmitting}
          >
            {saveButtonText}
          </Button>
        </div>
      </div>
    );
  }
}

IssueNew.propTypes = {
  beginPushpinWorkflow: PropTypes.func.isRequired,
  endPushpinWorkflow: PropTypes.func.isRequired,
  startDropPushpinAction: PropTypes.func.isRequired,
  endDropPushpinAction: PropTypes.func.isRequired,
  updatePushpinAction: PropTypes.func.isRequired,
  changeLocationAction: PropTypes.func.isRequired,
  resetFormAction: PropTypes.func.isRequired,
  resetValidityFormAction: PropTypes.func.isRequired,
  createRfiProcessStart: PropTypes.func.isRequired,
  createRfiProcessEnd: PropTypes.func.isRequired,
  pendingIssue: pendingIssueAttributesType,
  pendingIssueForm: pendingIssueFormAttributesType.isRequired,
  issuePushpin: activePushpinAttributesType,
  document: documentType.isRequired,
  targetUrn: PropTypes.string.isRequired,
  onCreateSuccess: PropTypes.func,
  onCancel: PropTypes.func,
};

IssueNew.displayName = 'IssueNew';

const mapStateToProps = (state) => ({
  allIssues: getAllIssues(state),
  pendingIssue: getPendingIssue(state),
  pendingIssueForm: getPendingIssueForm(state),
  issuePushpin: getActivePushpinAttributes(state),
  document: getCurrentDocument(state),
  oxygen: getOxygenMappings(state),
  targetUrn: getTargetUrn(state),
});

const { change: changeFormValueAction, reset: resetFormAction, resetValidity: resetValidityFormAction, setErrors: setErrorsFormAction } = formActions;

export default connect(mapStateToProps, {
  createIssueAction,
  beginPushpinWorkflow,
  endPushpinWorkflow,
  startDropPushpinAction,
  endDropPushpinAction,
  changeLocationAction,
  updatePushpinAction,
  changeFormValueAction,
  resetFormAction,
  resetValidityFormAction,
  setErrorsFormAction,
  createRfiProcessStart,
  createRfiProcessEnd,
})(IssueNew);
